// Util.setCookie('debug-realTimeListing', true)
import axios from 'axios';
import util from '@/common/util';

// Search interface optimization, using other separate interface in the middle
const REQUEST_URL_MAP = {
    default: '/api-site/search/realTimeListings',
    list: '/api-site/search/searchListListing',
    map: '/api-site/search/searchMapListing',
    nearby: '/api-site/search/nearby'
};

const getGlobalData = () => {
    return window.sitePrepareData() || {};
};

const getListingSearchSwitch = () => {
    const { listingSearchSwitch, searchCenter } = getGlobalData();
    const turnOnListingSearchSwitch =
        (util.getCookie('debug-realTimeListing') || listingSearchSwitch) &&
        searchCenter;
    return turnOnListingSearchSwitch;
};

const isMigrationAdvertLink = () => {
    const { migrationSite, isLandingPage } = getGlobalData();
    let { search = '' } = window.location;
    let isUnCenterLink = search && search.indexOf('condition=') === -1;
    let isAdvertisingLink =
        search.indexOf('x_ads_source') > -1 || search.indexOf('x_ads_id') > -1;
    return (
        !isLandingPage && migrationSite && isUnCenterLink && isAdvertisingLink
    );
};

const handleMigrationAdvertisLink = params => {
    let searchParams = { ...params };
    if (isMigrationAdvertLink()) {
        delete searchParams.condition;
    }
    // console.groupCollapsed(
    //     'searchRealTimeListings handleMigrationAdvertisLink:',
    //     searchParams
    // );
    // console.trace();
    // console.groupEnd();
    return searchParams;
};

// Global custom list field extensions
const extendReturnFields = params => {
    const { searchPersonalizingFields = '' } = getGlobalData();
    return {
        ...params,
        // View missing field keys in the search-request-return-fields-enum.json
        personalizingFields: searchPersonalizingFields
    };
};

// Reserve space for processing request parameters
const handleMdSearchCondition = params => {
    // The new search interface enables field optimization
    if (getListingSearchSwitch()) {
        params = extendReturnFields(params);
    }
    params = handleMigrationAdvertisLink(params);
    // params = params2linkHash(params);
    return params;
};

const getSearchRequestUrl = (type = 'default') => {
    if (getListingSearchSwitch()) {
        return REQUEST_URL_MAP[type];
    } else {
        return REQUEST_URL_MAP['default'];
    }
};

const mergeMlsOrg2HouseList = (houseList = [], mlsOrgList = []) => {
    return houseList.map(house => {
        if (!house.mlsOrg && mlsOrgList.length) {
            let mls = mlsOrgList.find(mlsOrg => mlsOrg.id === house.mlsOrgId);
            house.mlsOrg = Object.assign({}, mls || {}); // copy
            house.mlsOrg.cardTemplate = house.cardTemplate || '';
        }
        return house;
    });
};

const searchRealTimeListings = (params, type = 'default') => {
    // console.groupCollapsed('searchRealTimeListings:', params);
    // console.trace();
    // console.groupEnd();
    return axios.get(getSearchRequestUrl(type), { params });
};

const link2hashApi = {
    mapPath: {
        api: '/api-site/search-param/mapPath',
        responseKey: 'regionId'
    },
    quickSearch: {
        api: '/api-site/search-param/quickSearch',
        responseKey: 'optionId'
    }
};

const hashLinkCacheInitialValue = localStorage.getItem('hashLinkCache');
const hashLinkCache = hashLinkCacheInitialValue
    ? JSON.parse(hashLinkCacheInitialValue)
    : {};
const link2hashRequest = async (type, value) => {
    let { api, responseKey } = link2hashApi[type];
    let valueStr = JSON.stringify(value);
    if (hashLinkCache[valueStr]) {
        return hashLinkCache[valueStr];
    }
    try {
        let res = await axios.post(api, value);
        hashLinkCache[valueStr] = res.data[responseKey];
        localStorage.setItem('hashLinkCache', JSON.stringify(hashLinkCache));
        return res.data[responseKey];
    } catch (error) {
        console.error(error);
        return '';
    }
};

const params2linkHash = async params => {
    params = util.cloneData(params);
    const { searchCenter } = getGlobalData();
    let { mapPath, condition = '' } = params;
    if (searchCenter && condition.indexOf('mapPath') > -1) {
        condition = JSON.parse(condition);
        let temp = condition.location.mapPath.map(point => JSON.parse(point));
        condition.location.mapPath = await link2hashRequest('mapPath', temp);
        params.condition = JSON.stringify(condition);
    }
    if (mapPath) {
        params.mapPath = await link2hashRequest('mapPath', JSON.parse(mapPath));
    }
    return params;
};

export {
    isMigrationAdvertLink,
    handleMdSearchCondition,
    getSearchRequestUrl,
    searchRealTimeListings,
    mergeMlsOrg2HouseList,
    params2linkHash
};
